import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "preview-image-div" }
const _hoisted_2 = {
  key: 1,
  class: "pdf-preview"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("预览")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")
  const _component_icon = _resolveComponent("icon")
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isImage(_ctx.content.url))
      ? (_openBlock(), _createBlock(_component_a_image, {
          key: 0,
          src: _ctx.content.url
        }, null, 8, ["src"]))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_icon, {
            name: "pdf",
            scale: 6
          }),
          _createVNode("span", null, _toDisplayString(_ctx.content.name), 1)
        ])),
    _createVNode(_component_a_button, {
      type: "link",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download(_ctx.content)))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}